import * as React from 'react';
import {DateInput} from '@practicegenius/pg-ui/src/base/Material/components/DateInput';
import {IMT} from '@practicegenius/pg-util/src/StringUtils';
import {RegisterBirthdayScreenType} from '@practicegenius/register-account/src/screens/RegisterBirthday';
import {loginBottomText} from '../components/layout';
import {ProgressScreen} from '../../../components/screens/BaseScreen';

export const RegisterBirthday: RegisterBirthdayScreenType = ({
  lang,
  onFormSubmit,
  progress,
  actionButtons,
  birthdateInputProps,
  firstName,
}) => {
  return (
    <form onSubmit={onFormSubmit}>
      <ProgressScreen
        helmetTitle={lang.pageTitle}
        headerTitle={lang.headerTitle}
        progress={progress}
        title={IMT(lang.title, {firstName})}
        instructions={lang.instructions}
        actionButtons={[actionButtons.primary, actionButtons.secondary]}
        cancelProps={{href: '/'}}
        bottomText={loginBottomText}
      >
        <DateInput
          name="birthdate"
          placeholder=""
          value={birthdateInputProps.value}
          onChange={birthdateInputProps.onChange}
          InputProps={{onBlur: birthdateInputProps.onBlur}}
          label={lang.birthdateInput.label}
          error={birthdateInputProps.error}
          inputType="date"
          autoFocus
          inputStyle={{width: '100%'}}
        />
      </ProgressScreen>
    </form>
  );
};
